import React, { createContext, useContext, useEffect, useReducer, useState } from 'react';
import { partnersReducer, PARTNERS_ACTIONS } from '../reducers/partnersReducer';
import { useAuthState } from 'react-firebase-hooks/auth';
import {
    getPartners,
} from '../services/firebase/partners';
import { auth } from '../services/firebase/firebase';

const PartnersContext = createContext({});

export function usePartners() {
    return useContext(PartnersContext)
}

export const PartnersContextProvider = ({ children }) => {

    const [user, loading, error] = useAuthState(auth);
    const [state, dispatch] = useReducer(partnersReducer, { partners: [] })

    useEffect(() => {
        if (loading) return
        fetchPartners()
    }, [])

    const fetchPartners = async () => {
        const response = await getPartners()
        if (response.status === 'error') return alert(response.msg)
        dispatch({ type: PARTNERS_ACTIONS.FETCH_PARTNERS, payload: response })
    }

    const deletePartner = async (id) => {

    }

    const createPartner = async (data) => {

    }

    const updatePartner = async (partner) => {
        let data = partner
        const response = await updatePartner(partner.id, data)
        if (response.status === 'error') return alert(response.msg)
        dispatch({type: PARTNERS_ACTIONS.UPDATE_PARTNER, payload: data})
    }

    const value = {
        partners: state.partners,
        createPartner,
        updatePartner,
        deletePartner
    }

    return (
        <PartnersContext.Provider value={value}>
            {!loading && children}
        </PartnersContext.Provider>
    )
}